import styled from 'styled-components';
import { devices } from './breakpoints';

export const Root = styled.div`
	white-space: pre-line;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 50%;
	left: 0;
	right: 0;
	transform: translate(0, -50%);
	height: 100%;
	max-height: 812px;

	a {
		text-decoration: none;
		color: ${({ theme }) => theme.color.endeavour};
	}
	h3 {
		font-weight: normal;
		${({ theme }) => theme.mixin.title()};
		strong {
			${({ theme }) => theme.mixin.title()};
		}
	}
	${devices.phone} {
		width: 100%;
		height: 100%;
		max-height: none;
		padding: 0;
	}
`;
export const AppContainer = styled.div`
	width: 539px;
	background-color: ${({ theme }) => theme.color.white};
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 16px;
	box-sizing: border-box;
	height: 100%;

	${devices.phone} {
		width: 100%;
	}

	&::-webkit-scrollbar {
		display: none;
	}
	-ms-overflow-style: none;
	scrollbar-width: none;
	overflow-y: scroll;
`;
export const AppContainerWrapper = styled.div`
	height: 100%;
	position: relative;
	border: 1px solid ${({ theme }) => theme.color.porcelain};
	border-radius: 8px;
	overflow: hidden;
	${devices.phone} {
		width: 100%;
		border-radius: unset;
		border: unset;
	}
`;
export const AppContainerPage = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
